( function () {
	'use strict';

	function slideToggle () {
		return {
			'restrict' : 'A',
			'require'  : '^slideToggleBase',
			'scope'    : {
				'collapseIcon'    : '=',
				'collapseTooltip' : '=',
				'expandIcon'      : '=',
				'expandTooltip'   : '=',
				'startHidden'     : '='
			},

			'link' : function ( scope, element, attrs, baseCtrl ) {
				var icons = {
					'true'  : attrs.expandicon,
					'false' : attrs.collapseicon
				};

				var tooltipMessages = {
					'true'  : attrs.expandtooltip,
					'false' : attrs.collapsetooltip
				};

				baseCtrl.addToggle( element, tooltipMessages, icons, attrs.startHidden || false );
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'slideToggle', slideToggle );
} )();
